import { message } from "antd";

export const getReferenceColumn = (handleChangeValue) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Employee Code",
    dataIndex: "employee_code",
    key: "employee_code",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.employee_code || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Work Location",
    dataIndex: "work_location",
    key: "work_location",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.work_location || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },

  {
    title: "Company Name",
    dataIndex: "company_name",
    key: "company_name",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.company_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Contact Number",
    dataIndex: "contact_number",
    key: "contact_number",
    inputType: "number",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.contact_number || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getColumnsConfig = (handleChangeValue) => [
  {
    title: "Organization Name",
    dataIndex: "organization_name",
    key: "organization_name",
    type: "input",
    validations: { required: true },

    valuePath: (record, output) =>
      output?.[record.label]?.organization_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Designation",
    dataIndex: "designation",
    key: "designation",
    type: "input",
    validations: { required: true },

    valuePath: (record, output) => output?.[record.label]?.designation || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reason For Leaving",
    dataIndex: "reason_for_leaving",
    key: "reason_for_leaving",
    type: "input",
    validations: { required: true },

    valuePath: (record, output) =>
      output?.[record.label]?.reason_for_leaving || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Duration (From)",
    dataIndex: "from_date",
    key: "from_date",
    type: "datePicker",
    validations: { required: true },

    valuePath: (record, output) => output?.[record.label]?.from_date || null,
    onChange: (val, dataIndex, record) => {
      console.log(val, dataIndex, record);
      handleChangeValue(val, dataIndex, record.label);
    },
  },
  {
    title: "Duration (To)",
    dataIndex: "to_date",
    key: "to_date",
    type: "datePicker",
    validations: { required: true },

    hiddenWhen: (record, output, index) =>
      index === 0 && Boolean(output?.[record.label]?.currently_working_here),
    valuePath: (record, output) => output?.[record.label]?.to_date || null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Currently Working Here",
    dataIndex: "currently_working_here",
    key: "currently_working_here",
    type: "checkbox",
    hiddenWhen: (record, output, index) => index !== 0,
    valuePath: (record, output) =>
      output?.[record.label]?.currently_working_here || false,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getEmploymentAdditionalColumnsConfig = (handleChangeValue) => [
  {
    title: "Organization Address",
    dataIndex: "org_address",
    key: "org_address",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) => output?.[record.label]?.org_address || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },

  {
    title: "Employee ID",
    dataIndex: "emp_id",
    key: "emp_id",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) => output?.[record.label]?.emp_id || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },

  {
    title: "Employee Status",
    dataIndex: "emp_status",
    key: "emp_status",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) => output?.[record.label]?.emp_status || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Last Salary (Yearly)",
    dataIndex: "last_salary",
    key: "last_salary",
    type: "input",
    // validations: { required: true },

    valuePath: (record, output) => output?.[record.label]?.last_salary || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "HR Manager Name",
    dataIndex: "hr_manager_name",
    key: "hr_manager_name",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.hr_manager_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "HR Manager Contact",
    dataIndex: "hr_manager_contact",
    key: "hr_manager_contact",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.hr_manager_contact || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reporting Manager Name",
    dataIndex: "reporting_manager_name",
    key: "reporting_manager_name",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.reporting_manager_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reporting Manager Contact",
    dataIndex: "reporting_manager_contact",
    key: "reporting_manager_contact",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.reporting_manager_contact || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reference Name",
    dataIndex: "professional_reference_name",
    key: "professional_reference_name",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.professional_reference_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reference Designation",
    dataIndex: "professional_reference_designation",
    key: "professional_reference_designation",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.professional_reference_designation || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Relation (Professional / Personal )",
    dataIndex: "professional_reference_professional",
    key: "professional_reference_professional",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.professional_reference_professional || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reference Contact",
    dataIndex: "professional_reference_contact",
    key: "professional_reference_contact",
    type: "input",
    // validations: { required: true },
    valuePath: (record, output) =>
      output?.[record.label]?.professional_reference_contact || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getEmploymentDocumentColumnsConfig = (handleChangeValue) => [
  {
    title: "Salary Slip (Last 3 Months)",
    dataIndex: "salary_slip",
    key: "salary_slip",
    type: "file",
    validations: { required: true },

    valuePath: (record, output) =>
      output?.[record.label]?.documents?.salary_slip ||
      output?.[record.label]?.salary_slip ||
      null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Relieving Letter",
    dataIndex: "relieving_letter",
    key: "relieving_letter",
    type: "file",
    validations: { required: true },

    hiddenWhen: (record, output, index) =>
      index === 0 && Boolean(output?.[record.label]?.currently_working_here),
    valuePath: (record, output) =>
      output?.[record.label]?.documents?.relieving_letter ||
      output?.[record.label]?.relieving_letter ||
      null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Experience Letter",
    dataIndex: "experience_letter",

    key: "experience_letter",
    type: "file",
    validations: { required: true },
    hiddenWhen: (record, output, index) =>
      index === 0 && Boolean(output?.[record.label]?.currently_working_here),
    valuePath: (record, output) =>
      output?.[record.label]?.documents?.experience_letter ||
      output?.[record.label]?.experience_letter ||
      null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Offer Letter",
    dataIndex: "offer_letter",
    key: "offer_letter",
    type: "file",
    validations: { required: true },
    hiddenWhen: (record, output, index) =>
      !(index === 0 && output?.[record.label]?.currently_working_here),
    valuePath: (record, output) =>
      output?.[record.label]?.documents?.offer_letter ||
      output?.[record.label]?.offer_letter ||
      null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Resignation Acceptance Letter",
    dataIndex: "resignation_acceptance_letter",
    key: "resignation_acceptance_letter",
    type: "file",
    validations: { required: true },
    hiddenWhen: (record, output, index) =>
      !(index === 0 && output?.[record.label]?.currently_working_here),
    valuePath: (record, output) =>
      output?.[record.label]?.documents?.resignation_acceptance_letter ||
      output?.[record.label]?.resignation_acceptance_letter ||
      null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getFamilyColumnsConfig = (handleChangeValue, relationshipdrop) => [
  {
    title: "Relationship",
    dataIndex: "relationship",
    key: "relationship",
    type: "select",
    selectOptions: relationshipdrop,
    validations: { required: true, message: "Relationship is required" },
    valuePath: (record, output) => output?.[record.label]?.relationship || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    type: "input",
    validations: { required: true, message: "Name is required" },
    valuePath: (record, output) => output?.[record.label]?.name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },

  {
    title: "DOB",
    dataIndex: "dob",
    key: "dob",
    type: "datePicker",
    validations: { required: "DOB is required" },
    valuePath: (record, output) => output?.[record.label]?.dob || null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Nationality",
    dataIndex: "nationality",
    key: "nationality",
    type: "input",
    validations: { required: "Nationality is required" },
    valuePath: (record, output) => output?.[record.label]?.nationality || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Occupation",
    dataIndex: "occupation",
    key: "occupation",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.occupation || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getEduColumnsConfig = (handleChangeValue, edudrop) => [
  {
    title: "Qualification",
    dataIndex: "qualification",
    key: "qualification",
    type: "select",
    selectOptions: edudrop,
    validations: { required: true },

    valuePath: (record, output) => output?.[record.label]?.qualification || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Stream",
    dataIndex: "stream",
    key: "stream",
    type: "input",
    validations: { required: true },

    valuePath: (record, output) => output?.[record.label]?.stream || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "University/Institue",
    dataIndex: "board",
    key: "board",
    type: "input",

    validations: { required: true, message: "University/Institue is required" },
    valuePath: (record, output) => output?.[record.label]?.board || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Year of Passing",
    dataIndex: "year_of_passing",
    key: "year_of_passing",
    type: "input",
    inputType: "tel",
    maxLength: 4,
    validations: {
      required: "Year of Passing is required",
    },
    valuePath: (record, output) =>
      output?.[record.label]?.year_of_passing || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Grade/CGPA",
    dataIndex: "grade_cgpa",
    key: "grade_cgpa",
    type: "input",
    validations: { required: true },
    valuePath: (record, output) => output?.[record.label]?.grade_cgpa || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "ID/Roll no",
    dataIndex: "roll_no",
    key: "roll_no",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.roll_no || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

const EDUCATION_DOCUMENT_RULES = [
  {
    key: "tenth_certificate",
    title: "10th Certificate",
    keywords: ["10", "tenth", "ssc", "secondary", "matric"],
  },
  {
    key: "twelfth_certificate",
    title: "12th Certificate",
    keywords: ["12", "twelfth", "hsc", "higher secondary", "intermediate"],
  },
  {
    key: "graduation_certificate",
    title: "Graduation Certificate",
    keywords: [
      "graduation",
      "graduate",
      "degree",
      "bachelor",
      "ug",
      "b.sc",
      "bcom",
      "ba",
      "b.tech",
      "btech",
      "b.e",
      "be",
      "bca",
    ],
  },
  {
    key: "post_graduation_certificate",
    title: "Post Graduation Certificate",
    keywords: [
      "post graduation",
      "post graduate",
      "pg",
      "master",
      "mba",
      "mca",
      "msc",
      "m.com",
      "ma",
      "m.tech",
      "mtech",
    ],
  },
  {
    key: "any_other",
    title: "Any Other Certificate",
    keywords: ["other", "diploma", "certificate", "school", "nursing", "iti"],
  },
];

export const resolveEducationDocumentRule = (qualification = "") => {
  const normalized = String(qualification).toLowerCase();
  return (
    EDUCATION_DOCUMENT_RULES.find((rule) =>
      rule.keywords.some((keyword) => normalized.includes(keyword)),
    ) || EDUCATION_DOCUMENT_RULES[EDUCATION_DOCUMENT_RULES.length - 1]
  );
};

export const getEducationDocumentColumnsConfig = (handleChangeValue) =>
  EDUCATION_DOCUMENT_RULES.map((rule) => ({
    title: rule.title,
    dataIndex: rule.key,
    key: rule.key,
    type: "file",
    hiddenWhen: (record, output) => {
      const qualification = output?.[record.label]?.qualification || "";
      return resolveEducationDocumentRule(qualification).key !== rule.key;
    },
    valuePath: (record, output) => output?.[record.label]?.[rule.key] || null,
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  }));

export const getNomineeColumnsConfig = (
  handleChangeValue,
  relationshipdrop,
) => [
    {
      title: "Nominee's Name",
      dataIndex: "full_name",
      key: "full_name",
      type: "input",
      validations: { required: true },

      valuePath: (record, output) => output?.[record.label]?.full_name || "",
      onChange: (val, dataIndex, record) =>
        handleChangeValue(val, dataIndex, record.label),
    },
    {
      title: "Relationship with Nominee",
      dataIndex: "relationship",
      key: "relationship",
      type: "select",
      validations: { required: true },

      selectOptions: relationshipdrop,
      valuePath: (record, output) => output?.[record.label]?.relationship || "",
      onChange: (val, dataIndex, record) =>
        handleChangeValue(val, dataIndex, record.label),
    },
    {
      title: "Nominee's DOB",
      dataIndex: "dob",
      key: "dob",
      type: "datePicker",
      validations: { required: true },

      valuePath: (record, output) => output?.[record.label]?.dob || null,
      onChange: (val, dataIndex, record) =>
        handleChangeValue(val, dataIndex, record.label),
    },
    {
      title: "Nominee's Aadhar Number",
      dataIndex: "aadhar_number",
      key: "aadhar_number",
      type: "input",
      maxLength: 12,
      validations: { required: true },

      valuePath: (record, output) => output?.[record.label]?.aadhar_number || "",
      onChange: (val, dataIndex, record) =>
        handleChangeValue(val, dataIndex, record.label),
    },
    {
      title: "Share of Nominee(%)",
      dataIndex: "share_percentage",
      key: "share_percentage",
      validations: { required: true },

      type: "input",
      valuePath: (record, output) =>
        output?.[record.label]?.share_percentage || "",
      onChange: (val, dataIndex, record) =>
        handleChangeValue(val, dataIndex, record.label),
    },
  ];
